const baseUrl = process.env.VUE_APP_API_URL || "http://127.0.0.1:8000/api";
export default baseUrl;
